module.exports = __webpack_public_path__ + "media/images/shared/delivery/uraltrans-a83552f5fcb0dff5e0e2aa1b5e2e724c.png";